import { render, staticRenderFns } from "./NoticiaMedia.vue?vue&type=template&id=5b306bcb&scoped=true"
import script from "./NoticiaMedia.vue?vue&type=script&lang=js"
export * from "./NoticiaMedia.vue?vue&type=script&lang=js"
import style0 from "./NoticiaMedia.vue?vue&type=style&index=0&id=5b306bcb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b306bcb",
  null
  
)

export default component.exports